import React from 'react';
import Hero from '../components/Hero';
import Experience from '../components/Experience';
import { projects, skills, education } from '../data';
import { Link } from 'react-router-dom';

const Home = () => {
  const renderGrid = (type) => (
    <div className="grid-base">
      {projects.filter(p => p.category === type).map((project) => (
        <Link to={`/project/${project.slug}`} key={project.slug} className="no-underline">
          <div className="project-card">
            <span className="company-tag">{project.company}</span>
            <h3>{project.title}</h3>
            <p>{project.description}</p>
            <span className="view-more">Case Study →</span>
          </div>
        </Link>
      ))}
    </div>
  );

  return (
    <div>
      <Hero />
      
      <section id="skills" className="container">
        <h2>Technical Expertise</h2>
        <div className="skills-grid">
          {skills.map(skill => (
            <div key={skill.name} className="skill-card">
              <div className="skill-icon">{skill.icon}</div>
              <p>{skill.name}</p>
            </div>
          ))}
        </div>
      </section>

      <Experience />

      <section id="education" className="container">
        <h2>Education & Academy</h2>
        <div className="max-w-800">
          {education.map((edu, i) => (
            <div key={i} className="edu-card">
              <h3>{edu.degree}</h3>
              <span>{edu.institution} | {edu.date}</span>
              <p>{edu.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section id="projects" className="container">
        <h2>Professional Projects</h2>
        {renderGrid("Professional")}
        
        <h2 className="mt-80">My Personal Projects</h2>
        {renderGrid("Personal")}
      </section>
    </div>
  );
};

export default Home;